import type { ReactNode } from "react";

import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import styles from "./Box.module.scss";

export type BoxVariant = "level-1" | "level-2";
export type BoxTitleAs = "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export type BoxProps = SafeHtmlAttributes<HTMLDivElement> & {
  title: string;
  variant?: BoxVariant;
  titleAs?: BoxTitleAs;
  hasError?: boolean;
  children: ReactNode;
};

const variantClassMap: Record<NonNullable<BoxProps["variant"]>, string> = {
  "level-1": styles.variantLevel1,
  "level-2": styles.variantLevel2,
};

export const Box = ({ title, children, variant = "level-1", titleAs = "p", hasError = false, ...rest }: BoxProps) => {
  const TitleTag = titleAs;

  return (
    <div className={classnames(styles.box, variantClassMap[variant], { [styles.error]: hasError })} {...rest}>
      <TitleTag className={styles.title}>{title}</TitleTag>
      <div className={styles.body}>{children}</div>
    </div>
  );
};
